export default "__VITE_ASSET__eff9f069__"